module.exports = __webpack_public_path__ + "img/new_row_pic.2cfd1e56.png";